import { ApprovalStatus } from './type';

export const statusList = [
  { label: '全部', id: '' },
  { label: '待生效', id: 0 },
  { label: '生效中', id: 1 },
  { label: '失效', id: 2 },
];
export const approvalStatusList = [
  { label: '全部', id: ApprovalStatus.ALL },
  { label: '待审核', id: ApprovalStatus.WAIT },
  { label: '审核驳回', id: ApprovalStatus.REJECT },
  { label: '审核通过', id: ApprovalStatus.PASSED },
];
export const typeList = [
  { label: '企业', id: 0, value: 'business' },
  { label: '个人', id: 1, value: '' },
  { label: '人群包', id: 5 },
];
export const takeTypeList = [
  { label: '企业', id: 0 },
  { label: '全部用户', id: 2 },
  { label: '新用户', id: 3 },
  { label: '老用户', id: 4 },
  { label: '人群包', id: 5 },
];
export const releaseMethodList = [
  { label: '需领取', id: 0 },
  { label: '进账户', id: 1 },
];
export const typeEnums = {
  company: { value: 0 },
  people: { value: 1 },
  allPeople: { value: 2 },
  newPeople: { value: 3 },
  oldPeople: { value: 4 },
  package: { value: 5 },
};
export const releaseMethodEnums = {
  receive: { value: 0 },
  account: { value: 1 },
};
export const platformList = [{ label: '微信小程序', id: 1 }];

export const listOperate = {
  waitAble: 0,
  able: 1,
  disable: 2,
};

export const ticketStatusList = {
  all: { text: '全部', key: 0 },
  has_received: { text: '已领取', key: 1 },
  has_checked: { text: '已核销', key: 2 },
  has_deleted: { text: '已作废', key: 3 },
};

export const platformMap = ['无', '微信小程序'];
export const statusMap = ['待生效', '生效中', '失效'];
export const typeMap = ['企业', '个人', '全部用户', '新用户', '老用户', '人群包'];
export const ticketStatusMap = ['全部', '已领取', '已核销', '已作废'];
export const methodMap = ['需领取', '进账户'];
